<template>
  <div>
    <div v-if="loading">
      <px-circular-loading/>
    </div>
    <figure v-if="!loaded || (loaded && historico && historico.length)">
      <v-chart :options="chart"
               ref="comprasChart"
               theme="primary"
               autoresize/>
    </figure>
    <div v-if="loaded && (!historico || !historico.length)"
         align="center"
         class="body-1 mb-5 mt-5">
      Ainda não há históricos de preço
    </div>
  </div>
</template>

<script>
import chartMixin from '@/mixins/chart-mixin';
import { toEchartData } from '@/utils/chart-utils';
import HistoricoPreco from '@/api/historico-preco';
import { chain } from 'lodash';
import moment from 'moment';

export default {
  mixins: [chartMixin],
  props: {
    produto: {
      type: Object,
      required: true,
    },
    unidadeMedida: {
      type: Object,
      required: true,
    },
    showTitle: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      loaded: false,
      historico: null,
      chart: null,
      loading: false,
    };
  },
  methods: {
    buildChartData() {
      return chain(this.historico)
        .map((hist) => {
          const current = moment(hist.dataCompra);
          const dataKey = current.format('YYYYMMDD');
          const description = current.format('DD/MM/YYYY');
          return {
            dataKey,
            description,
            value: hist.precoUnitario || 0,
          };
        })
        .sortBy('dataKey')
        .value();
    },
    buildTitle() {
      if (this.historico && this.historico.length) {
        return {
          text: `Histórico de preço por ${this.unidadeMedida.descricao}`,
        };
      }
      return {
        textStyle: {
          color: 'grey',
          fontSize: 20,
        },
        text: 'No data',
        left: 'center',
        top: 'center',
      };
    },
    buildChart() {
      const historicos = this.buildChartData();
      return {
        title: this.showTitle ? this.buildTitle() : null,
        tooltip: {
          formatter: this.tooltipFormatter,
        },
        dataset: {
          source: [
            ['Histórico'],
            ...toEchartData(historicos, 'description', 'value'),
          ],
        },
        xAxis: {
          type: 'category',
          interval: 1,
          maxInterval: 1,
          splitNumber: 1,
        },
        yAxis: {
          axisLabel: {
            formatter: this.axisMoneyFormatter,
          },
        },
        grid: {
          left: '15%',
        },
        series: [{ type: 'line' }],
      };
    },
    getHistorico() {
      const query = `produto = ${this.produto.id} and unidadeMedida=${this.unidadeMedida.id} order by dataCompra desc`;

      this.loading = true;
      HistoricoPreco.getHistoricoPrecos({ query })
        .then((response) => {
          this.historico = response.data;
          this.chart = this.buildChart();
          this.loaded = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.getHistorico();
  },
};
</script>

<style scoped>

figure {
  width: 100%;
  border: none;
  border-radius: 0;
  box-shadow: none;
}

figure .echarts {
  width: 100%;
}

</style>
